import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { useTheme } from '../context/ThemeContext';

export default function Register() {
  const [form, setForm] = useState({ name:'', email:'', password:'', confirm:'' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const toast = useToast();
  const { isDark, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault(); setError('');
    if (form.password !== form.confirm) return setError('Les mots de passe ne correspondent pas.');
    if (form.password.length < 6) return setError('Minimum 6 caractères.');
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success('Compte créé avec succès ! Bienvenue 🎉');
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur lors de la création du compte.');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-page">
      <div className="auth-grid-bg" />
      <div className="auth-glow" />
      <button
        onClick={toggleTheme}
        style={{ position:'fixed', top:'1.25rem', right:'1.25rem', zIndex:10,
          background:'var(--bg-card)', border:'1px solid var(--border)',
          borderRadius:'var(--radius-sm)', padding:'0.5rem 0.75rem',
          cursor:'pointer', fontSize:'0.85rem', color:'var(--text-secondary)',
          display:'flex', alignItems:'center', gap:'0.4rem', fontFamily:'var(--font)' }}
      >
        {isDark ? '☀️ Clair' : '🌙 Sombre'}
      </button>

      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon">⚡</div>
          <span className="auth-logo-text">TaskFlow</span>
        </div>
        <h1 className="auth-title">Créer un compte</h1>
        <p className="auth-subtitle">Commencez à organiser vos tâches gratuitement.</p>

        {error && <div className="alert alert-error">⚠️ {error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Nom complet</label>
            <input className="form-input" type="text" name="name"
              value={form.name} onChange={handleChange} placeholder="Jean Dupont" required />
          </div>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="form-input" type="email" name="email"
              value={form.email} onChange={handleChange} placeholder="vous@exemple.com" required />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Mot de passe</label>
              <input className="form-input" type="password" name="password"
                value={form.password} onChange={handleChange} placeholder="Min. 6 caractères" required />
            </div>
            <div className="form-group">
              <label className="form-label">Confirmer</label>
              <input className="form-input" type="password" name="confirm"
                value={form.confirm} onChange={handleChange} placeholder="••••••••" required />
            </div>
          </div>
          <button className="btn btn-primary" type="submit" disabled={loading}>
            {loading ? '⏳ Création...' : '→ Créer mon compte'}
          </button>
        </form>
        <div className="auth-footer">
          Déjà un compte ? <Link to="/login">Se connecter</Link>
        </div>
      </div>
    </div>
  );
}
